import { createRouter, createWebHistory } from 'vue-router';
import { auth0, waitForAuth0Ready } from '@/main';
import ScribeLayout from '@/layouts/ScribeLayout.vue';

const isSuperAdmin = () =>
  auth0.user.value?.['https://manta.vet/roles']?.includes('superadmin') ??
  false;

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/scribe/sessions',
    },
    {
      path: '/scribe',
      component: ScribeLayout,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          redirect: '/scribe/sessions',
        },
        {
          path: 'sessions',
          name: 'sessions',
          component: () => import('@/views/SessionsEmpty.vue'),
          meta: { title: 'Sessions', sessionList: true },
        },
        {
          path: 'sessions/:id',
          name: 'session-detail',
          component: () => import('@/views/SessionWorkspace.vue'),
          meta: { title: 'Session', sessionList: true },
        },
        {
          path: 'templates',
          name: 'templates',
          component: () => import('@/views/TemplatesView.vue'),
          meta: { title: 'Templates' },
        },
        {
          path: 'templates/:id',
          name: 'template-editor',
          component: () => import('@/views/TemplateEditorView.vue'),
          meta: { title: 'Template' },
        },
        {
          path: 'templates/:id/form',
          name: 'form-editor',
          component: () => import('@/views/FormEditorView.vue'),
          meta: { title: 'Form' },
        },
      ],
    },
    {
      path: '/preview/mobile',
      name: 'preview-scribe-mobile',
      component: () => import('@/views/preview/ScribeMobilePreviewView.vue'),
      meta: { requiresAuth: true, requiresSuperAdmin: true },
    },
    {
      path: '/callback',
      name: 'callback',
      component: () => import('@/views/CallbackView.vue'),
    },
  ],
});

router.beforeEach(async (to, _from, next) => {
  if (import.meta.env.VITE_DISABLE_AUTH === 'true') {
    return next();
  }
  if (to.meta.requiresAuth) {
    await waitForAuth0Ready();
    if (!auth0.isAuthenticated.value) {
      await auth0.loginWithRedirect({ appState: { target: to.fullPath } });
      return next(false);
    }
    if (to.meta.requiresSuperAdmin && !isSuperAdmin()) {
      return next({ name: 'sessions' });
    }
    return next();
  }
  next();
});

router.onError((error, to) => {
  if (
    error.message.includes('Failed to fetch dynamically imported module') ||
    error.message.includes('Importing a module script failed') ||
    error.message.includes('error loading dynamically imported module')
  ) {
    const url = new URL(to.fullPath, window.location.origin);
    if (
      url.origin === window.location.origin &&
      (url.protocol === 'http:' || url.protocol === 'https:')
    ) {
      window.location.assign(`${url.pathname}${url.search}${url.hash}`);
    } else {
      window.location.reload();
    }
  }
});

export default router;
